<template>
  <div v-if="show" class="tabbar-container">
    <div class="large-button-bg"></div>

    <div class="tabbar-bg-box">
      <img
        class="tabbar-bg-img tabbar-bg-img--light"
        :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/bg-light.svg')"
        alt=""
        aria-hidden="true"
      />
      <img
        class="tabbar-bg-img tabbar-bg-img--dark"
        :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/bg-dark.svg')"
        alt=""
        aria-hidden="true"
      />
    </div>

    <van-tabbar v-model="active" route placeholder :safe-area-inset-bottom="false" @change="onChange">
      <!-- replace to="/" -->
      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content', { __on: active == 0 }]">
            <div v-show="active == 0" class="icon-active-wrap">
              <span class="tabbar-icon-glow" aria-hidden="true"></span>
              <div class="icon-active-layers">
                <span
                  class="icon-layer icon-layer--theme"
                  :style="getTabOnThemeMaskStyle('home')"
                  aria-hidden="true"
                ></span>
                <img
                  class="icon __on icon-layer--shadow"
                  :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/home_on_shadow.png')"
                />
              </div>
            </div>
            <img
              v-show="active != 0"
              class="icon"
              :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/home_off.png')"
            />
            <span class="name">Início</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content', { __on: active == 1 }]">
            <div v-show="active == 1" class="icon-active-wrap">
              <span class="tabbar-icon-glow" aria-hidden="true"></span>
              <div class="icon-active-layers">
                <span
                  class="icon-layer icon-layer--theme"
                  :style="getTabOnThemeMaskStyle('top-up')"
                  aria-hidden="true"
                ></span>
                <img
                  class="icon __on icon-layer--shadow"
                  :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/top-up_on_shadow.png')"
                />
              </div>
            </div>
            <img
              v-show="active != 1"
              class="icon"
              :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/top-up_off.png')"
            />
            <span class="name">Depósito</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content __plus', { __on: active == 2 }]">
            <img class="icon __plus" :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/acting.png')" />
            <span class="name">Agente</span>
          </div>
        </template>
      </van-tabbar-item>

      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content', { __on: active == 3 }]">
            <div v-show="active == 3" class="icon-active-wrap">
              <span class="tabbar-icon-glow" aria-hidden="true"></span>
              <div class="icon-active-layers">
                <span
                  class="icon-layer icon-layer--theme"
                  :style="getTabOnThemeMaskStyle('activity')"
                  aria-hidden="true"
                ></span>
                <img
                  class="icon __on icon-layer--shadow"
                  :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/activity_on_shadow.png')"
                />
              </div>
            </div>
            <img
              v-show="active != 3"
              class="icon"
              :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/activity_off.png')"
            />
            <span class="name">Promoções</span>
          </div>
        </template>
      </van-tabbar-item>

      <!-- replace to="/Personal" -->
      <van-tabbar-item>
        <template #icon>
          <div :class="['tabbar-item-content', { __on: active == 4 }]">
            <div v-show="active == 4" class="icon-active-wrap">
              <span class="tabbar-icon-glow" aria-hidden="true"></span>
              <div class="icon-active-layers">
                <span
                  class="icon-layer icon-layer--theme"
                  :style="getTabOnThemeMaskStyle('user')"
                  aria-hidden="true"
                ></span>
                <img
                  class="icon __on icon-layer--shadow"
                  :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/user_on_shadow.png')"
                />
              </div>
            </div>
            <img
              v-show="active != 4"
              class="icon"
              :src="getImageUrlWithCDN_LOCAL('/tabbar/index_50000/user_off.png')"
            />
            <span class="name">Perfil</span>
          </div>
        </template>
      </van-tabbar-item>
    </van-tabbar>

    <LoginRegisterPopup ref="LoginRegisterRef" />
  </div>
</template>

<script setup>
import { getTabOnThemeMaskStyle, useTabBarTemplate } from './js/index.js'

const {
  active,
  LoginRegisterRef,
  onChange,
  show,
} = useTabBarTemplate()
</script>

<style lang="less" scoped>
@import url('./css/index.less');

.tabbar-container {
  .tabbar-item-content {
    @icon_size: 30px;

    .icon-active-wrap {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
    }

    .tabbar-icon-glow {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 32px;
      height: 32px;
      transform: translate(-50%, -48%);
      border-radius: 50%;
      background: var(--tabbar-icon-glow-color);
      filter: blur(var(--tabbar-icon-glow-blur));
      pointer-events: none;
      z-index: 0;
    }

    .icon-active-layers {
      position: relative;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      z-index: 1;
    }

    .icon-layer--theme {
      position: absolute;
      top: 50%;
      left: 50%;
      width: @icon_size;
      height: @icon_size;
      transform: translate(-50%, -50%);
      background: var(--tabbar-icon-active-bg);
      -webkit-mask-repeat: no-repeat;
      mask-repeat: no-repeat;
      -webkit-mask-position: center;
      mask-position: center;
      -webkit-mask-size: contain;
      mask-size: contain;
      filter: var(--tabbar-icon-theme-filter);
      pointer-events: none;
    }

    .icon-active-wrap .icon.__on,
    .icon-layer--shadow {
      position: relative;
      z-index: 1;
    }

    &.__on {
      .icon.__on {
        border-radius: 50%;
      }
    }
  }
}
</style>
